module.exports = __webpack_public_path__ + "img/bill-printer.11cfb736.svg";